import { useState } from "react";

/* ─────────────────────────────────────────
   LOGO PALETTE
   #e8899a  script-A pink
   #ffffff  white
   #1a1a1a  black
   #888888  grey
───────────────────────────────────────── */
const PINK    = "#e8899a";   // logo script-A pink
const PINK2   = "#c45f78";   // darker for hover/depth
const PINK_BG = "#fffbfc";   // almost white with barely-there pink
const PINK_LT = "#fdf0f3";   // very soft blush (was fde8ed)
const PINK_BD = "#f5dde3";   // softer pink border (was f0cdd5)
const BLACK   = "#1a1a1a";
const GREY    = "#888888";
const GREY_LT = "#c0c0c0";
const WHITE   = "#ffffff";

/* ─────────────────────────────────────────
   DATA  — all categories renamed
───────────────────────────────────────── */
const PRODUCTS = [
  {
    id:1,
    name:"Stage 2 Zipper Garment",
    price:150,
    orig:null,
    category:"Post-Op Garments",
    stock:14,
    tag:"",
    sizes:["S","M","L","XL","2XL","3XL","4XL"],
    colors:["Black","Cocoa"],
    desc:"High-compression Stage 2 post-op garment with lateral zipper closure. Easier to put on and take off while still providing firm compression throughout your recovery. Available in Black and Cocoa. Sizes S–4XL.",
    badge:"Stage 2 · Lateral Zipper",
    photos:{
      "Black":["/images/zipper-black-1.jpg","/images/zipper-black-2.jpg","/images/zipper-black-3.jpg","/images/zipper-black-4.jpg"],
      "Cocoa":["/images/zipper-cocoa-1.jpg","/images/zipper-cocoa-2.jpg","/images/zipper-cocoa-3.jpg"],
    }
  },
  {
    id:2,
    name:"Stage 2 Hook Garment",
    price:150,
    orig:null,
    category:"Post-Op Garments",
    stock:11,
    tag:"",
    sizes:["S","M","L","XL","2XL","3XL","4XL"],
    colors:["Black","Cocoa"],
    desc:"Maximum-compression Stage 2 garment with hook closure for the most sculpted, snatched silhouette. Recommended for later in Stage 2 recovery once the mid-abdomen is ready for increased pressure. Available in Black and Cocoa. Sizes S–4XL.",
    badge:"Stage 2 · Maximum Compression",
    photos:{
      "Black":["/images/hook-black-1.jpg","/images/hook-black-2.jpg","/images/hook-black-3.jpg","/images/hook-black-4.jpg"],
      "Cocoa":["/images/hook-cocoa-1.jpg","/images/hook-cocoa-2.jpg","/images/hook-cocoa-3.jpg","/images/hook-cocoa-4.jpg"],
    }
  },
];

const ORDERS = [
  { id:"#2041", customer:"Destiny M.",  items:2, total:184, status:"Shipped",    date:"Mar 9",  avatar:"D", note:"BBL recovery kit" },
  { id:"#2040", customer:"Alicia R.",   items:1, total:95,  status:"Processing", date:"Mar 9",  avatar:"A", note:"Stage 2 garment" },
  { id:"#2039", customer:"Keisha T.",   items:3, total:219, status:"Delivered",  date:"Mar 8",  avatar:"K", note:"Bundle + extras" },
  { id:"#2038", customer:"Yesenia V.",  items:1, total:89,  status:"Delivered",  date:"Mar 7",  avatar:"Y", note:"BBL garment" },
  { id:"#2037", customer:"Brianna S.",  items:2, total:137, status:"Cancelled",  date:"Mar 6",  avatar:"B", note:"Waist cincher set" },
  { id:"#2036", customer:"Camila F.",   items:1, total:149, status:"Shipped",    date:"Mar 5",  avatar:"C", note:"Recovery bundle" },
  { id:"#2035", customer:"Jasmine P.",  items:4, total:301, status:"Delivered",  date:"Mar 4",  avatar:"J", note:"Full post-op kit" },
];

const CHART = [
  {m:"Apr",v:4200},{m:"May",v:5800},{m:"Jun",v:5100},{m:"Jul",v:7200},
  {m:"Aug",v:6600},{m:"Sep",v:8400},{m:"Oct",v:7900},{m:"Nov",v:9600},
  {m:"Dec",v:11200},{m:"Jan",v:8900},{m:"Feb",v:10400},{m:"Mar",v:12800},
];

/* ─────────────────────────────────────────
   CSS
───────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;1,9..40,300&display=swap');

*,*::before,*::after { box-sizing:border-box; margin:0; padding:0; }
html { scroll-behavior:smooth; }
body { background:${WHITE}; color:${BLACK}; font-family:'DM Sans',sans-serif; font-weight:300; line-height:1.6; -webkit-font-smoothing:antialiased; }
::-webkit-scrollbar { width:3px; }
::-webkit-scrollbar-thumb { background:${PINK_BD}; border-radius:4px; }
input,select,textarea,button { font-family:'DM Sans',sans-serif; }

.serif { font-family:'Cormorant Garamond',serif; }

@keyframes fadeUp  { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
@keyframes fadeIn  { from{opacity:0} to{opacity:1} }
@keyframes slideR  { from{opacity:0;transform:translateX(24px)} to{opacity:1;transform:translateX(0)} }

.fade-up  { animation:fadeUp  .6s cubic-bezier(.22,1,.36,1) both; }
.fade-in  { animation:fadeIn  .3s ease both; }
.slide-r  { animation:slideR  .4s cubic-bezier(.22,1,.36,1) both; }

.card-hover { transition:transform .3s ease, box-shadow .3s ease; cursor:pointer; }
.card-hover:hover { transform:translateY(-3px); box-shadow:0 12px 40px rgba(232,137,154,.18); }

/* Primary — pink filled */
.btn-primary {
  background:${PINK}; color:${WHITE}; border:none;
  padding:12px 28px; font-size:12px; font-weight:500;
  letter-spacing:.1em; text-transform:uppercase; border-radius:2px;
  cursor:pointer; transition:all .25s;
}
.btn-primary:hover { background:${PINK2}; }

/* Secondary — black outline */
.btn-secondary {
  background:transparent; color:${BLACK}; border:1px solid ${BLACK};
  padding:11px 26px; font-size:12px; font-weight:500;
  letter-spacing:.1em; text-transform:uppercase; border-radius:2px;
  cursor:pointer; transition:all .2s;
}
.btn-secondary:hover { background:${BLACK}; color:${WHITE}; }

/* Ghost — subtle pink */
.btn-ghost {
  background:transparent; color:${PINK2}; border:1px solid ${PINK_BD};
  padding:7px 18px; font-size:11px; font-weight:500;
  letter-spacing:.08em; text-transform:uppercase; border-radius:2px;
  cursor:pointer; transition:all .2s;
}
.btn-ghost:hover { background:${PINK_LT}; }

.label {
  display:inline-block; padding:2px 10px; border-radius:2px;
  font-size:10px; font-weight:500; letter-spacing:.1em; text-transform:uppercase;
}

.input-field {
  background:${WHITE}; border:1px solid ${PINK_BD}; border-radius:2px;
  padding:10px 14px; font-size:13px; color:${BLACK};
  outline:none; transition:border-color .2s; width:100%;
  font-family:'DM Sans',sans-serif; font-weight:300;
}
.input-field:focus { border-color:${PINK}; }
.input-field::placeholder { color:${GREY_LT}; }

/* Divider rule */
.rule { border:none; border-top:1px solid ${PINK_BD}; }

/* Modal desktop padding */
.modal-wrapper { padding:16px; }

/* Comparison outer wrapper */
.comparison-outer { padding:80px 48px; background:${WHITE}; border-bottom:1px solid ${PINK_BD}; }

/* ── MOBILE ── */
@media (max-width: 768px) {

  /* NAV */
  .nav-links { display:none !important; }
  .nav-inner {
    padding:0 16px !important;
    height:60px !important;
    grid-template-columns:auto 1fr auto !important;
    gap:8px !important;
  }
  .nav-wa-text { display:none !important; }

  /* HERO — full width centered */
  .hero {
    padding:48px 20px 44px !important;
    min-height:auto !important;
  }
  .hero h1 { font-size:36px !important; line-height:1.05 !important; }
  .hero p { font-size:14px !important; max-width:100% !important; }
  .hero-btns {
    flex-direction:column !important;
    width:100% !important;
    gap:10px !important;
    margin-bottom:32px !important;
  }
  .hero-btns button { width:100% !important; padding:15px !important; }
  .hero-stats {
    gap:0 !important;
    padding-top:20px !important;
    justify-content:space-between !important;
  }

  /* SOCIAL PROOF BAR */
  .social-bar {
    padding:12px 16px !important;
    justify-content:center !important;
    flex-wrap:wrap !important;
    gap:6px 0 !important;
    overflow:visible !important;
  }
  .social-bar span { padding:0 10px !important; font-size:9px !important; letter-spacing:.1em !important; }

  /* PRODUCTS SECTION */
  #products { padding:40px 16px 48px !important; }
  .product-grid {
    grid-template-columns:1fr !important;
    gap:32px !important;
    padding:0 !important;
  }
  .product-card-img { height:480px !important; }

  /* STYLE COMPARISON — stack on mobile */
  .comparison-outer { padding:40px 16px !important; }
  .comparison-grid { grid-template-columns:1fr !important; gap:0 !important; }
  .comparison-section { padding:36px 20px !important; }

  /* CTA STRIP */
  .cta-strip {
    padding:48px 20px !important;
    flex-direction:column !important;
    text-align:center !important;
    gap:24px !important;
    align-items:stretch !important;
  }
  .cta-strip h2 { font-size:28px !important; }
  .cta-strip a,
  .cta-strip button { width:100% !important; justify-content:center !important; }

  /* FOOTER */
  .footer { padding:40px 16px 0 !important; }
  .footer-top { gap:40px !important; }
  .footer-top > div { text-align:center !important; }

  /* MODAL */
  .modal-wrapper { padding:0 !important; align-items:flex-end !important; }
  .modal-box {
    flex-direction:column !important;
    width:100vw !important;
    height:100dvh !important;
    max-height:100dvh !important;
    border-radius:0 !important;
    overflow:hidden !important;
  }
  .modal-image {
    width:100% !important;
    height:48vh !important;
    min-height:48vh !important;
    max-height:48vh !important;
    border-right:none !important;
    border-bottom:1px solid ${PINK_BD} !important;
    flex-shrink:0 !important;
  }
  .modal-image img { object-fit:contain !important; object-position:center center !important; }
  .modal-details {
    overflow-y:auto !important;
    -webkit-overflow-scrolling:touch !important;
    flex:1 !important;
    display:flex !important;
    flex-direction:column !important;
    min-height:0 !important;
  }
  .modal-details > div:first-child {
    padding:14px 16px 12px !important;
    overflow-y:auto !important;
    flex:1 !important;
    min-height:0 !important;
  }
  .modal-details > div:last-child {
    padding:12px 16px !important;
    padding-bottom:max(12px,env(safe-area-inset-bottom)) !important;
    flex-shrink:0 !important;
  }
  .modal-details h2 { font-size:17px !important; margin-bottom:6px !important; }
  .modal-close {
    position:fixed !important;
    top:12px !important;
    right:12px !important;
    font-size:26px !important;
    width:44px !important;
    height:44px !important;
    display:flex !important;
    align-items:center !important;
    justify-content:center !important;
    background:rgba(255,255,255,.95) !important;
    border-radius:50% !important;
    z-index:500 !important;
    box-shadow:0 2px 12px rgba(0,0,0,.2) !important;
  }
  .thumb-strip { gap:5px !important; padding:6px 8px !important; overflow-x:auto !important; flex-wrap:nowrap !important; }
  .thumb-strip > div { width:42px !important; height:42px !important; flex-shrink:0 !important; }
  .expand-btn { display:flex !important; }

  /* CART DRAWER */
  .cart-drawer { width:100vw !important; }

  /* RECOVERY GUIDE */
  .rg-hero { padding:40px 16px 36px !important; }
  .rg-section { padding:40px 16px !important; }
  .rg-stages { grid-template-columns:1fr !important; }
  .rg-steps { grid-template-columns:1fr 1fr !important; }
  .rg-weeks { grid-template-columns:1fr !important; }
  .rg-tips { grid-template-columns:1fr !important; }
  .size-table div { padding:8px 8px !important; font-size:10px !important; }
}

@media (max-width: 400px) {
  .hero h1 { font-size:32px !important; }
  .rg-steps { grid-template-columns:1fr !important; }
  .modal-image { height:42vh !important; min-height:42vh !important; max-height:42vh !important; }
}
`;

/* ─────────────────────────────────────────
   WHATSAPP SVG ICON
───────────────────────────────────────── */
const WAIcon = ({ size=16, color=WHITE }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={{flexShrink:0}}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.118 1.524 5.849L.057 23.535a.75.75 0 00.908.908l5.684-1.467A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.725 9.725 0 01-4.963-1.355l-.355-.212-3.683.95.969-3.585-.231-.368A9.725 9.725 0 012.25 12C2.25 6.615 6.615 2.25 12 2.25S21.75 6.615 21.75 12 17.385 21.75 12 21.75z"/>
  </svg>
);

/* ─────────────────────────────────────────
   LOGO — real image, home button
───────────────────────────────────────── */
const Logo = ({ size=48, onClick }) => (
  <div onClick={onClick} style={{display:"flex",alignItems:"center",cursor:onClick?"pointer":"default"}}>
    <img
      src={process.env.PUBLIC_URL + "/logo.png"}
      alt="Alo's Elevated Beauty"
      style={{height:size,width:"auto",objectFit:"contain"}}
    />
  </div>
);

/* ─────────────────────────────────────────
   BADGES
───────────────────────────────────────── */
const TagLabel = ({label}) => {
  if (!label) return null;
  const m = {
    Bestseller:  {bg:"#fdf3e3",c:"#9a6b1a"},
    New:         {bg:"#eef6f0",c:"#2d6a45"},
    Sale:        {bg:PINK_LT,  c:PINK2},
    "Best Value":{bg:"#eef2fb",c:"#2c4fa0"},
    "Low Stock": {bg:PINK_LT,  c:PINK2},
  };
  const s = m[label]||{bg:PINK_LT,c:PINK2};
  return <span className="label" style={{background:s.bg,color:s.c}}>{label}</span>;
};

const StatusLabel = ({status}) => {
  const m = {
    Shipped:    {bg:"#eef2fb",c:"#2c4fa0"},
    Processing: {bg:"#fdf3e3",c:"#9a6b1a"},
    Delivered:  {bg:"#eef6f0",c:"#2d6a45"},
    Cancelled:  {bg:PINK_LT,  c:PINK2},
  };
  const s = m[status]||{bg:PINK_LT,c:GREY};
  return <span className="label" style={{background:s.bg,color:s.c}}>{status}</span>;
};

/* ─────────────────────────────────────────
   CART DRAWER
───────────────────────────────────────── */
const CartDrawer = ({cart,onClose,onRemove,onQty}) => {
  const total = cart.reduce((s,i)=>s+i.price*i.qty,0);
  const count = cart.reduce((s,i)=>s+i.qty,0);
  return (
    <div style={{position:"fixed",inset:0,zIndex:300}} className="fade-in">
      <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(26,26,26,.35)",backdropFilter:"blur(3px)"}}/>
      <div className="slide-r" style={{
        position:"absolute",right:0,top:0,bottom:0,width:"min(400px,100vw)",
        background:WHITE,display:"flex",flexDirection:"column",
        borderLeft:`1px solid ${PINK_BD}`,
      }}>
        {/* header */}
        <div style={{padding:"28px 28px 22px",borderBottom:`1px solid ${PINK_BD}`,display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
          <div>
            <div className="serif" style={{fontSize:28,fontWeight:500,color:BLACK,lineHeight:1}}>Your Bag</div>
            <div style={{fontSize:12,color:GREY,marginTop:6,letterSpacing:".04em"}}>{count} item{count!==1?"s":""}</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:22,color:GREY_LT,cursor:"pointer",lineHeight:1,padding:"2px 4px"}}>×</button>
        </div>

        {/* items */}
        <div style={{flex:1,overflowY:"auto",padding:"20px 28px"}}>
          {cart.length===0 ? (
            <div style={{textAlign:"center",paddingTop:80,color:GREY}}>
              <div className="serif" style={{fontSize:22,marginBottom:10,color:BLACK,fontStyle:"italic"}}>Your bag is empty</div>
              <div style={{fontSize:13,letterSpacing:".04em"}}>Add items to get started</div>
            </div>
          ) : cart.map(item=>(
            <div key={item.id+item.size+item.color} style={{display:"flex",gap:14,marginBottom:20,paddingBottom:20,borderBottom:`1px solid ${PINK_BD}`}}>
              <div style={{width:64,height:76,background:PINK_BG,border:`1px solid ${PINK_BD}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:11,color:GREY,letterSpacing:".06em",textTransform:"uppercase",textAlign:"center",padding:4}}>
                {item.name.split(" ").slice(0,2).join("\n")}
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:500,marginBottom:3,color:BLACK,lineHeight:1.3}}>{item.name}</div>
                <div style={{fontSize:11,color:GREY,marginBottom:12,letterSpacing:".04em"}}>{item.size} · {item.color}</div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{display:"flex",alignItems:"center",gap:1}}>
                    <button onClick={()=>onQty(item.id,item.size,item.color,-1)} style={{background:"none",border:`1px solid ${PINK_BD}`,width:28,height:28,fontSize:14,color:BLACK,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>−</button>
                    <span style={{fontSize:12,fontWeight:500,width:32,textAlign:"center",color:BLACK,borderTop:`1px solid ${PINK_BD}`,borderBottom:`1px solid ${PINK_BD}`,height:28,display:"flex",alignItems:"center",justifyContent:"center"}}>{item.qty}</span>
                    <button onClick={()=>onQty(item.id,item.size,item.color,1)} style={{background:"none",border:`1px solid ${PINK_BD}`,width:28,height:28,fontSize:13,color:BLACK,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>+</button>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:14}}>
                    <span style={{fontWeight:500,color:BLACK,fontSize:14,letterSpacing:".02em"}}>${item.price*item.qty}</span>
                    <button onClick={()=>onRemove(item.id,item.size,item.color)} style={{background:"none",border:"none",color:GREY_LT,fontSize:16,cursor:"pointer",lineHeight:1}}>×</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {cart.length>0 && (
          <div style={{padding:"20px 24px max(28px,env(safe-area-inset-bottom))",borderTop:`1px solid ${PINK_BD}`}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:10}}>
              <span style={{fontSize:11,color:GREY,letterSpacing:".06em"}}>Subtotal</span>
              <span style={{fontSize:15,fontWeight:500,color:BLACK}}>${total.toFixed(2)}</span>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:10}}>
              <span style={{fontSize:11,color:GREY,letterSpacing:".06em"}}>CA Tax (10.25%)</span>
              <span style={{fontSize:15,fontWeight:500,color:BLACK}}>${(total*0.1025).toFixed(2)}</span>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:20,paddingTop:12,borderTop:`1px solid ${PINK_BD}`}}>
              <span style={{fontSize:11,fontWeight:500,letterSpacing:".1em",textTransform:"uppercase",color:BLACK}}>Total</span>
              <span className="serif" style={{fontSize:26,fontWeight:500,color:BLACK}}>${(total*1.1025).toFixed(2)}</span>
            </div>
            <div style={{fontSize:10,color:GREY_LT,letterSpacing:".06em",marginBottom:14,textAlign:"center"}}>California sales tax included · Orders ship 1–2 business days</div>
            <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{textDecoration:"none",display:"block"}}>
              <button className="btn-primary" style={{width:"100%",padding:"14px",fontSize:12,borderRadius:2}}>Order via WhatsApp</button>
            </a>
            <div style={{display:"flex",gap:20,justifyContent:"center",marginTop:14,fontSize:11,color:GREY_LT,letterSpacing:".04em"}}>
              <span>10-day returns</span>
              <span>·</span>
              <span>Ships 1–2 business days</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────
   PRODUCT MODAL
───────────────────────────────────────── */
const ProductModal = ({product,onClose,onAdd}) => {
  const [size,setSize]               = useState(product.sizes[0]);
  const [color,setColor]             = useState(product.colors[0]);
  const [qty,setQty]                 = useState(1);
  const [activePhoto,setActivePhoto] = useState(0);
  const [lightbox,setLightbox]       = useState(false);

  // ALWAYS derive photos from current color state — never store separately
  // This is the correct fix: no useState for photos, just compute from color
  const currentPhotos = product.photos[color] || product.photos[product.colors[0]];

  const handleColorChange = (c) => {
    setColor(c);
    setActivePhoto(0);
  };

  // Guard: ensure activePhoto never exceeds current photo array length
  const safeIndex = Math.min(activePhoto, currentPhotos.length - 1);

  return (
    <div className="fade-in modal-wrapper" style={{position:"fixed",inset:0,zIndex:200,display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(26,26,26,.5)",backdropFilter:"blur(4px)"}}/>

      {/* LIGHTBOX */}
      {lightbox && (
        <div onClick={()=>setLightbox(false)} style={{position:"fixed",inset:0,zIndex:400,background:"rgba(0,0,0,.95)",display:"flex",alignItems:"center",justifyContent:"center"}}>
          <img key={`lb-${color}-${safeIndex}`} src={`${process.env.PUBLIC_URL}${currentPhotos[safeIndex]}?c=${color}&i=${safeIndex}`} alt="" style={{maxWidth:"100%",maxHeight:"100%",objectFit:"contain"}}/>
          <button onClick={()=>setLightbox(false)} style={{position:"absolute",top:16,right:16,background:"rgba(255,255,255,.15)",border:"none",color:"#fff",width:44,height:44,borderRadius:"50%",fontSize:22,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
          {safeIndex > 0 && <button onClick={e=>{e.stopPropagation();setActivePhoto(a=>a-1)}} style={{position:"absolute",left:16,top:"50%",transform:"translateY(-50%)",background:"rgba(255,255,255,.15)",border:"none",color:"#fff",width:44,height:44,borderRadius:"50%",fontSize:20,cursor:"pointer"}}>‹</button>}
          {safeIndex < currentPhotos.length-1 && <button onClick={e=>{e.stopPropagation();setActivePhoto(a=>a+1)}} style={{position:"absolute",right:16,top:"50%",transform:"translateY(-50%)",background:"rgba(255,255,255,.15)",border:"none",color:"#fff",width:44,height:44,borderRadius:"50%",fontSize:20,cursor:"pointer"}}>›</button>}
        </div>
      )}

      <div className="fade-up modal-box" style={{
        position:"relative",zIndex:1,
        width:"100%",maxWidth:820,maxHeight:"92vh",
        background:WHITE,display:"flex",flexDirection:"row",
        overflow:"hidden",border:`1px solid ${PINK_BD}`,
        boxShadow:"0 24px 80px rgba(0,0,0,.15)",
      }}>

        {/* IMAGE PANEL */}
        <div className="modal-image" style={{
          width:300,flexShrink:0,background:PINK_BG,
          display:"flex",flexDirection:"column",
          borderRight:`1px solid ${PINK_BD}`,overflow:"hidden",
        }}>
          <div style={{flex:1,overflow:"hidden",position:"relative",minHeight:0,cursor:"zoom-in"}} onClick={()=>setLightbox(true)}>
            <img
              key={`main-${color}-${safeIndex}`}
              src={`${process.env.PUBLIC_URL}${currentPhotos[safeIndex]}?c=${color}&i=${safeIndex}`}
              alt={product.name}
              style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"center center"}}
            />
            <div className="expand-btn" style={{display:"none",position:"absolute",bottom:10,right:10,background:"rgba(0,0,0,.45)",color:"#fff",borderRadius:4,padding:"4px 8px",fontSize:10,letterSpacing:".06em",textTransform:"uppercase",gap:4,alignItems:"center"}}>⤢ Expand</div>
          </div>
          {currentPhotos.length > 1 && (
            <div className="thumb-strip" style={{display:"flex",gap:4,padding:"8px",background:WHITE,borderTop:`1px solid ${PINK_BD}`,flexWrap:"wrap"}}>
              {currentPhotos.map((ph,i)=>(
                <div key={`${color}-thumb-${i}`} onClick={()=>setActivePhoto(i)} style={{
                  width:52,height:52,overflow:"hidden",cursor:"pointer",flexShrink:0,
                  border:`1.5px solid ${safeIndex===i?PINK:PINK_BD}`,
                  opacity:safeIndex===i?1:.65,transition:"all .2s",
                }}>
                  <img src={process.env.PUBLIC_URL + ph} alt="" style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"center"}}/>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* DETAILS PANEL */}
        <div className="modal-details" style={{flex:1,display:"flex",flexDirection:"column",overflowY:"auto",position:"relative",minWidth:0}}>
          <div style={{flex:1,padding:"36px 32px 24px",overflowY:"auto"}}>
            <button className="modal-close" onClick={onClose} style={{position:"absolute",top:14,right:16,background:"none",border:"none",fontSize:24,color:GREY_LT,cursor:"pointer",lineHeight:1,zIndex:2}}>×</button>

            <div style={{fontSize:10,letterSpacing:".14em",textTransform:"uppercase",color:PINK,marginBottom:8,fontWeight:500}}>{product.category}</div>
            <h2 className="serif" style={{fontSize:"clamp(20px,3vw,32px)",fontWeight:500,lineHeight:1.15,marginBottom:10,color:BLACK,paddingRight:32}}>{product.name}</h2>

            <div style={{marginBottom:14}}>
              <span className="serif" style={{fontSize:28,fontWeight:500,color:BLACK}}>${product.price}</span>
            </div>

            <p style={{fontSize:13,color:GREY,lineHeight:1.9,marginBottom:18,borderBottom:`1px solid ${PINK_BD}`,paddingBottom:16}}>{product.desc}</p>

            {/* COLOR */}
            <div style={{marginBottom:16}}>
              <div style={{fontSize:10,fontWeight:500,letterSpacing:".1em",textTransform:"uppercase",color:GREY,marginBottom:8}}>Color — <span style={{color:BLACK,fontWeight:600}}>{color}</span></div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {product.colors.map(c=>(
                  <button key={c} onClick={()=>handleColorChange(c)} style={{
                    padding:"8px 20px",fontSize:12,fontWeight:500,letterSpacing:".06em",
                    border:`2px solid ${color===c?PINK:PINK_BD}`,
                    background:color===c?PINK_LT:WHITE,
                    color:color===c?PINK2:GREY,
                    cursor:"pointer",borderRadius:2,transition:"all .2s",
                  }}>{c}</button>
                ))}
              </div>
            </div>

            {/* SIZE */}
            <div style={{marginBottom:20}}>
              <div style={{fontSize:10,fontWeight:500,letterSpacing:".1em",textTransform:"uppercase",color:GREY,marginBottom:8}}>Size — <span style={{color:BLACK,fontWeight:600}}>{size}</span></div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {product.sizes.map(s=>(
                  <button key={s} onClick={()=>setSize(s)} style={{
                    minWidth:44,height:38,fontSize:11,fontWeight:500,
                    border:`2px solid ${size===s?PINK:PINK_BD}`,
                    background:size===s?PINK_LT:WHITE,
                    color:size===s?PINK2:GREY,
                    cursor:"pointer",borderRadius:2,padding:"0 10px",transition:"all .2s",
                  }}>{s}</button>
                ))}
              </div>
            </div>

            <div style={{display:"flex",flexWrap:"wrap",gap:12,fontSize:11,color:GREY,letterSpacing:".04em"}}>
              <span>✓ Stage 2 Compression</span>
              <span>✓ Ships within 1–2 days</span>
              <span>✓ 10-day returns</span>
            </div>
          </div>

          {/* STICKY ADD TO BAG — always visible, never cut off */}
          <div style={{padding:"16px 24px",borderTop:`1px solid ${PINK_BD}`,background:WHITE,flexShrink:0}}>
            <div style={{display:"flex",gap:10,alignItems:"stretch"}}>
              <div style={{display:"flex",alignItems:"center",border:`1px solid ${PINK_BD}`,flexShrink:0}}>
                <button onClick={()=>setQty(q=>Math.max(1,q-1))} style={{background:"none",border:"none",width:44,height:48,fontSize:20,color:BLACK,cursor:"pointer"}}>−</button>
                <span style={{width:36,textAlign:"center",fontWeight:500,fontSize:14,color:BLACK,borderLeft:`1px solid ${PINK_BD}`,borderRight:`1px solid ${PINK_BD}`,height:48,display:"flex",alignItems:"center",justifyContent:"center"}}>{qty}</span>
                <button onClick={()=>setQty(q=>q+1)} style={{background:"none",border:"none",width:44,height:48,fontSize:16,color:BLACK,cursor:"pointer"}}>+</button>
              </div>
              <button
                className="btn-primary"
                style={{flex:1,padding:"14px",fontSize:12,borderRadius:2,minHeight:48}}
                onClick={()=>{ onAdd({...product,size,color,qty}); onClose(); }}
              >Add to Bag</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────
   STOREFRONT
───────────────────────────────────────── */
const Storefront = ({cart,onAdd,onOpenCart,onGuide,onOrder,onReturns}) => {
  const [selected,setSelected] = useState(null);
  const cartCount = cart.reduce((s,i)=>s+i.qty,0);

  return (
    <div style={{minHeight:"100vh",background:WHITE}}>

      {/* NAV */}
      <nav className="nav-inner" style={{
        position:"sticky",top:0,zIndex:100,background:WHITE,
        borderBottom:`1px solid ${PINK_BD}`,padding:"0 40px",height:70,
        display:"grid",gridTemplateColumns:"auto 1fr auto",alignItems:"center",gap:24,
      }}>
        {/* left — logo */}
        <Logo size={70}/>
        {/* center — nav links */}
        <div className="nav-links" style={{display:"flex",gap:32,alignItems:"center",justifyContent:"center"}}>
          <span onClick={()=>document.getElementById('products')?.scrollIntoView({behavior:'smooth'})} style={{fontSize:11,fontWeight:400,color:GREY,cursor:"pointer",letterSpacing:".1em",textTransform:"uppercase",whiteSpace:"nowrap"}} onMouseEnter={e=>e.target.style.color=BLACK} onMouseLeave={e=>e.target.style.color=GREY}>Shop</span>
          <span onClick={onOrder} style={{fontSize:11,fontWeight:400,color:GREY,cursor:"pointer",letterSpacing:".1em",textTransform:"uppercase",whiteSpace:"nowrap"}} onMouseEnter={e=>e.target.style.color=BLACK} onMouseLeave={e=>e.target.style.color=GREY}>How to Order</span>
          <span onClick={onGuide} style={{fontSize:11,fontWeight:400,color:GREY,cursor:"pointer",letterSpacing:".1em",textTransform:"uppercase",whiteSpace:"nowrap"}} onMouseEnter={e=>e.target.style.color=BLACK} onMouseLeave={e=>e.target.style.color=GREY}>Recovery Guide</span>
        </div>
        {/* right — whatsapp + bag */}
        <div className="nav-right" style={{display:"flex",gap:12,alignItems:"center",justifyContent:"flex-end"}}>
          <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer"
            style={{display:"flex",alignItems:"center",gap:6,color:"#25d366",textDecoration:"none",fontSize:11,fontWeight:500,letterSpacing:".06em",textTransform:"uppercase"}}>
            <WAIcon size={15} color="#25d366"/><span className="nav-wa-text">WhatsApp</span>
          </a>
          <div style={{width:1,height:16,background:PINK_BD}}/>
          <button onClick={onOpenCart} style={{background:"none",border:"none",padding:"4px 0",cursor:"pointer",display:"flex",alignItems:"center",gap:7,fontSize:11,fontWeight:500,color:BLACK,letterSpacing:".08em",textTransform:"uppercase"}}>
            Bag
            {cartCount>0 && <span style={{background:PINK,color:WHITE,minWidth:17,height:17,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:600}}>{cartCount}</span>}
          </button>
        </div>
      </nav>

      {/* HERO — full width centered */}
      <div className="hero" style={{padding:"96px 48px 80px",background:WHITE,borderBottom:`1px solid ${PINK_BD}`,textAlign:"center",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",left:"50%",top:"50%",transform:"translate(-50%,-50%)",width:"min(600px,90vw)",height:"min(600px,90vw)",borderRadius:"50%",background:PINK_LT,opacity:.25,zIndex:0,pointerEvents:"none"}}/>
        <div style={{position:"relative",zIndex:1,maxWidth:680,margin:"0 auto"}}>
          <div style={{fontSize:10,letterSpacing:".28em",textTransform:"uppercase",color:PINK,marginBottom:24,fontWeight:500}}>
            Stage 2 · Post-Op Garments
          </div>
          <h1 className="serif" style={{fontSize:"clamp(36px,6vw,88px)",fontWeight:400,lineHeight:1.05,marginBottom:28,color:BLACK,letterSpacing:"-.02em"}}>
            Recover with <span style={{color:PINK,fontStyle:"italic"}}>confidence</span><br/>and grace.
          </h1>
          <p style={{fontSize:15,color:GREY,lineHeight:1.85,maxWidth:480,fontWeight:300,margin:"0 auto 40px"}}>
            Premium Stage 2 compression garments. Two styles, two colors, sizes S–4XL. Designed for the woman who refuses to compromise on her results.
          </p>
          <div className="hero-btns" style={{display:"flex",gap:12,flexWrap:"wrap",justifyContent:"center",marginBottom:56}}>
            <button className="btn-primary" style={{fontSize:11,padding:"15px 36px",letterSpacing:".14em"}} onClick={()=>document.getElementById('products')?.scrollIntoView({behavior:'smooth'})}>Shop Now</button>
            <button onClick={onGuide} className="btn-secondary" style={{fontSize:11,padding:"15px 28px",letterSpacing:".14em"}}>Recovery Guide</button>
          </div>
          <div className="hero-stats" style={{display:"flex",gap:40,justifyContent:"center",paddingTop:32,borderTop:`1px solid ${PINK_BD}`}}>
            {[["S – 4XL","All sizes"],["2 Styles","Zipper & Hook"],["10-Day","Return policy"]].map(([h,s])=>(
              <div key={h}>
                <div style={{fontSize:13,fontWeight:500,color:BLACK}}>{h}</div>
                <div style={{fontSize:11,color:GREY,marginTop:2,fontWeight:300}}>{s}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* SOCIAL PROOF BAR */}
      <div className="social-bar" style={{background:BLACK,padding:"14px 24px",display:"flex",justifyContent:"center",alignItems:"center",flexWrap:"wrap",gap:"10px 0",overflow:"hidden"}}>
        {[
          "✦  Maximum Compression",
          "✦  Sizes S – 4XL",
          "✦  Black & Cocoa",
          "✦  10-Day Returns",
          "✦  Ships in 1–2 Days",
        ].map((t,i)=>(
          <span key={i} style={{fontSize:10,fontWeight:400,color:"rgba(255,255,255,.7)",letterSpacing:".16em",textTransform:"uppercase",padding:"0 20px",whiteSpace:"nowrap"}}>{t}</span>
        ))}
      </div>

      {/* PRODUCTS */}
      <div id="products" style={{padding:"80px 48px",background:WHITE}}>
        <div style={{textAlign:"center",marginBottom:56}}>
          <div style={{fontSize:10,letterSpacing:".22em",textTransform:"uppercase",color:PINK,marginBottom:14,fontWeight:500}}>Choose Your Style</div>
          <h2 className="serif" style={{fontSize:"clamp(32px,3.5vw,52px)",fontWeight:400,color:BLACK,lineHeight:1.1}}>Two garments.<br/>One <span style={{fontStyle:"italic",color:PINK}}>perfect</span> recovery.</h2>
        </div>

        <div className="product-grid" style={{display:"grid",gridTemplateColumns:"repeat(2,minmax(300px,520px))",gap:32,justifyContent:"center",maxWidth:1100,margin:"0 auto"}}>
          {PRODUCTS.map((p,i)=>(
            <div key={p.id} className="fade-up" style={{animationDelay:`${i*.1}s`,cursor:"pointer",background:WHITE}} onClick={()=>setSelected(p)}>
              {/* image */}
              <div className="product-card-img" style={{height:520,overflow:"hidden",position:"relative",background:PINK_BG}}>
                <img
                  src={process.env.PUBLIC_URL + p.photos[p.colors[0]][0]}
                  alt={p.name}
                  style={{width:"100%",height:"100%",objectFit:"contain",objectPosition:"center center",transition:"transform .6s cubic-bezier(.22,1,.36,1)",background:PINK_BG}}
                  onMouseEnter={e=>e.target.style.transform="scale(1.05)"}
                  onMouseLeave={e=>e.target.style.transform="scale(1)"}
                />
                {/* color indicator overlay */}
                <div style={{position:"absolute",bottom:16,left:16,display:"flex",gap:6}}>
                  {p.colors.map(c=>(
                    <div key={c} style={{
                      width:20,height:20,borderRadius:"50%",
                      background:c==="Black"?"#1a1a1a":"#9b7b6b",
                      border:`2px solid white`,
                      boxShadow:"0 1px 4px rgba(0,0,0,.25)",
                    }} title={c}/>
                  ))}
                </div>
              </div>
              {/* card info */}
              <div style={{padding:"24px 4px 8px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                  <div>
                    <div style={{fontSize:17,fontWeight:500,color:BLACK,marginBottom:4,lineHeight:1.2}}>{p.name}</div>
                    <div style={{fontSize:12,color:GREY,fontWeight:300,lineHeight:1.6,maxWidth:340}}>{p.desc.slice(0,90)}…</div>
                  </div>
                  <div className="serif" style={{fontSize:24,fontWeight:500,color:BLACK,flexShrink:0,marginLeft:16}}>${p.price}</div>
                </div>
                <div style={{marginTop:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontSize:10,color:GREY_LT,letterSpacing:".1em",textTransform:"uppercase"}}>Black · Cocoa · S–4XL</span>
                  <span style={{fontSize:11,fontWeight:500,color:PINK,letterSpacing:".08em",textTransform:"uppercase",cursor:"pointer"}}>View Details →</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* STYLE COMPARISON — which one is right for me */}
      <div className="comparison-outer">
        <div style={{textAlign:"center",marginBottom:48}}>
          <div style={{fontSize:10,letterSpacing:".22em",textTransform:"uppercase",color:PINK,marginBottom:14,fontWeight:500}}>Which Style Is Right For Me?</div>
          <h2 className="serif" style={{fontSize:"clamp(28px,3vw,44px)",fontWeight:400,color:BLACK}}>Know your <span style={{fontStyle:"italic"}}>stage.</span></h2>
        </div>
        <div className="comparison-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,background:PINK_BD,maxWidth:900,margin:"0 auto"}}>
          {[
            {name:"Zipper Garment",tag:"Weeks 4–8",color:PINK_LT,border:PINK_BD,points:["Lateral zipper — easy to put on solo","Firm Stage 2 compression","Great for early Stage 2 transition","Gentler on the mid-abdomen","Best for daily wear and bathroom access"]},
            {name:"Hook Garment",tag:"Weeks 8+",color:WHITE,border:PINK_BD,points:["Hook closure — maximum snatch","Highest compression level","Best snatched silhouette result","Recommended once mid-abdomen is healed","Preferred by surgeons for late Stage 2"]},
          ].map(s=>(
            <div className="comparison-section" key={s.name} style={{background:s.color,padding:"36px 32px"}}>
              <div style={{fontSize:10,letterSpacing:".16em",textTransform:"uppercase",color:GREY,marginBottom:10,fontWeight:500}}>{s.tag}</div>
              <h3 className="serif" style={{fontSize:26,fontWeight:500,color:BLACK,marginBottom:24}}>{s.name}</h3>
              {s.points.map(pt=>(
                <div key={pt} style={{display:"flex",gap:12,marginBottom:12,alignItems:"flex-start"}}>
                  <div style={{width:5,height:5,borderRadius:"50%",background:PINK,flexShrink:0,marginTop:7}}/>
                  <span style={{fontSize:13,color:GREY,lineHeight:1.7,fontWeight:300}}>{pt}</span>
                </div>
              ))}
              <button className="btn-primary" style={{marginTop:24,fontSize:11,padding:"12px 28px",width:"100%"}} onClick={()=>setSelected(PRODUCTS.find(p=>p.name.toLowerCase().includes(s.name.split(' ')[0].toLowerCase())))}>
                Shop {s.name} →
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* CTA STRIP */}
      <div className="cta-strip" style={{background:BLACK,padding:"80px 48px",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:32}}>
        <div>
          <div style={{fontSize:10,letterSpacing:".22em",textTransform:"uppercase",color:PINK,marginBottom:16}}>Personal Guidance</div>
          <h2 className="serif" style={{fontSize:"clamp(28px,3vw,44px)",fontWeight:400,color:WHITE,lineHeight:1.1,marginBottom:14}}>Not sure where<br/>to start?</h2>
          <p style={{fontSize:13,color:"rgba(255,255,255,.5)",maxWidth:460,lineHeight:1.9,fontWeight:300}}>
            Message us on WhatsApp. We'll ask about your procedure, your recovery stage, and help you find the right garment, size, and color. Personal service, every time.
          </p>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:12,flexShrink:0}}>
          <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{textDecoration:"none"}}>
            <button style={{background:"#25d366",color:WHITE,border:"none",padding:"16px 40px",fontSize:12,fontWeight:500,cursor:"pointer",letterSpacing:".12em",textTransform:"uppercase",display:"flex",alignItems:"center",gap:10,width:"100%",justifyContent:"center"}}>
              <WAIcon size={16} color={WHITE}/> Chat on WhatsApp
            </button>
          </a>
          <button onClick={onGuide} style={{background:"none",border:`1px solid rgba(255,255,255,.2)`,color:"rgba(255,255,255,.6)",padding:"14px 40px",fontSize:11,fontWeight:400,cursor:"pointer",letterSpacing:".12em",textTransform:"uppercase",width:"100%"}}>
            Read Recovery Guide
          </button>
        </div>
      </div>

      {/* FOOTER */}
      <div className="footer" style={{background:WHITE,borderTop:`1px solid ${PINK_BD}`,padding:"64px 48px 0"}}>

        {/* TOP — tagline centered */}
        <div style={{textAlign:"center",marginBottom:48}}>
          {/* tagline content */}
          <div style={{paddingTop:8}}>
            <div className="serif" style={{fontSize:"clamp(26px,3.5vw,44px)",fontWeight:400,color:BLACK,lineHeight:1.1,marginBottom:16}}>
              Recover with <span style={{color:PINK,fontStyle:"italic"}}>confidence</span><br/>and grace.
            </div>
            <p style={{fontSize:12,color:GREY,lineHeight:1.8,fontWeight:300,maxWidth:340,margin:"0 auto 16px"}}>
              Premium Stage 2 post-op compression garments.<br/>Designed for maximum results, made for every body.
            </p>
            <a href="https://instagram.com/aloselevatedbeauty" target="_blank" rel="noreferrer"
              style={{display:"inline-flex",alignItems:"center",gap:8,textDecoration:"none",color:GREY,fontSize:11,letterSpacing:".08em",textTransform:"uppercase"}}
              onMouseEnter={e=>e.currentTarget.style.color=PINK}
              onMouseLeave={e=>e.currentTarget.style.color=GREY}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              @aloselevatedbeauty
            </a>
          </div>
        </div>

        {/* MID — shop + support links centered */}
        <div style={{borderTop:`1px solid ${PINK_BD}`,paddingTop:40,marginBottom:32}}>
          <div className="footer-top" style={{display:"flex",justifyContent:"center",gap:80,flexWrap:"wrap"}}>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:10,letterSpacing:".16em",textTransform:"uppercase",color:BLACK,fontWeight:500,marginBottom:16}}>Shop</div>
              {[["Stage 2 Zipper",()=>setSelected(PRODUCTS[0])],["Stage 2 Hook",()=>setSelected(PRODUCTS[1])],["How to Order",onOrder]].map(([l,fn])=>(
                <div key={l} onClick={fn} style={{fontSize:12,color:GREY,cursor:"pointer",marginBottom:10,fontWeight:300}} onMouseEnter={e=>e.target.style.color=PINK} onMouseLeave={e=>e.target.style.color=GREY}>{l}</div>
              ))}
            </div>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:10,letterSpacing:".16em",textTransform:"uppercase",color:BLACK,fontWeight:500,marginBottom:16}}>Support</div>
              {[["Recovery Guide",onGuide],["Returns Policy",onReturns],["Contact Us","https://wa.link/35yhqt"]].map(([l,fn])=>(
                <div key={l} onClick={typeof fn==="string"?()=>window.open(fn):fn} style={{fontSize:12,color:GREY,cursor:"pointer",marginBottom:10,fontWeight:300}} onMouseEnter={e=>e.target.style.color=PINK} onMouseLeave={e=>e.target.style.color=GREY}>{l}</div>
              ))}
            </div>
          </div>
        </div>

        {/* BOTTOM — policy links then copyright at very bottom */}
        <div style={{borderTop:`1px solid ${PINK_BD}`,padding:"20px 0 28px",textAlign:"center"}}>
          <div style={{display:"flex",justifyContent:"center",gap:24,marginBottom:14,flexWrap:"wrap"}}>
            <span onClick={()=>window.open("https://wa.link/35yhqt")} style={{fontSize:11,color:GREY,cursor:"pointer",letterSpacing:".06em",textTransform:"uppercase"}} onMouseEnter={e=>e.target.style.color=PINK} onMouseLeave={e=>e.target.style.color=GREY}>Privacy</span>
            <span style={{color:PINK_BD}}>·</span>
            <span onClick={onOrder} style={{fontSize:11,color:GREY,cursor:"pointer",letterSpacing:".06em",textTransform:"uppercase"}} onMouseEnter={e=>e.target.style.color=PINK} onMouseLeave={e=>e.target.style.color=GREY}>Shipping</span>
            <span style={{color:PINK_BD}}>·</span>
            <span onClick={onReturns} style={{fontSize:11,color:GREY,cursor:"pointer",letterSpacing:".06em",textTransform:"uppercase"}} onMouseEnter={e=>e.target.style.color=PINK} onMouseLeave={e=>e.target.style.color=GREY}>Returns</span>
            <span style={{color:PINK_BD}}>·</span>
            <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{fontSize:11,color:GREY,textDecoration:"none",letterSpacing:".06em",textTransform:"uppercase"}} onMouseEnter={e=>e.target.style.color=PINK} onMouseLeave={e=>e.target.style.color=GREY}>Contact</a>
          </div>
          <div style={{fontSize:11,color:GREY_LT,letterSpacing:".04em"}}>© 2026 Alo's Elevated Beauty. All rights reserved.</div>
        </div>

      </div>

      {selected && <ProductModal product={selected} onClose={()=>setSelected(null)} onAdd={item=>{onAdd(item);setSelected(null);}}/>}
    </div>
  );
};

/* ─────────────────────────────────────────
   REVENUE CHART
───────────────────────────────────────── */
const RevenueChart = () => {
  const [hov,setHov] = useState(null);
  const max = Math.max(...CHART.map(d=>d.v));
  return (
    <div style={{height:140,display:"flex",alignItems:"flex-end",gap:4}}>
      {CHART.map((d,i)=>(
        <div key={d.m} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"default"}}
          onMouseEnter={()=>setHov(i)} onMouseLeave={()=>setHov(null)}>
          {hov===i && <div style={{fontSize:10,fontWeight:500,color:PINK,background:PINK_LT,padding:"2px 7px",border:`1px solid ${PINK_BD}`,whiteSpace:"nowrap",marginBottom:2}}>${(d.v/1000).toFixed(1)}k</div>}
          <div style={{width:"100%",height:Math.round((d.v/max)*108),background:hov===i?PINK:PINK_LT,border:`1px solid ${hov===i?PINK2:PINK_BD}`,transition:"all .2s"}}/>
          <div style={{fontSize:9,fontWeight:400,color:GREY_LT,letterSpacing:".04em"}}>{d.m}</div>
        </div>
      ))}
    </div>
  );
};

/* ─────────────────────────────────────────
   ADMIN
───────────────────────────────────────── */
const Admin = () => {
  const [section,setSection]   = useState("overview");
  const [products,setProducts] = useState(PRODUCTS);
  const [orders]               = useState(ORDERS);
  const [pSearch,setPSearch]   = useState("");
  const [oSearch,setOSearch]   = useState("");
  const [oFilter,setOFilter]   = useState("All");
  const [toast,setToast]       = useState(null);

  const showToast = (msg,type="ok")=>{ setToast({msg,type}); setTimeout(()=>setToast(null),2800); };
  const totalRev  = CHART.reduce((s,d)=>s+d.v,0);
  const avgOrder  = Math.round(orders.reduce((s,o)=>s+o.total,0)/orders.length);
  const delivered = orders.filter(o=>o.status==="Delivered").length;
  const filtProd  = products.filter(p=>p.name.toLowerCase().includes(pSearch.toLowerCase())||p.category.toLowerCase().includes(pSearch.toLowerCase()));
  const filtOrd   = orders.filter(o=>(oFilter==="All"||o.status===oFilter)&&(o.id.toLowerCase().includes(oSearch.toLowerCase())||o.customer.toLowerCase().includes(oSearch.toLowerCase())));

  const navItems = [
    {id:"overview", label:"Overview",  icon:"○"},
    {id:"products", label:"Products",  icon:"□"},
    {id:"orders",   label:"Orders",    icon:"◇"},
    {id:"analytics",label:"Analytics", icon:"△"},
  ];

  return (
    <div style={{display:"flex",minHeight:"100vh",background:PINK_BG}}>

      {/* SIDEBAR */}
      <div style={{width:224,flexShrink:0,background:WHITE,borderRight:`1px solid ${PINK_BD}`,display:"flex",flexDirection:"column",position:"sticky",top:0,height:"100vh"}}>
        <div style={{padding:"24px 22px 20px",borderBottom:`1px solid ${PINK_BD}`}}>
          <Logo size={70} />
          <div style={{fontSize:9,letterSpacing:".16em",textTransform:"uppercase",color:GREY_LT,marginTop:10}}>Admin Console</div>
        </div>

        <nav style={{flex:1,padding:"16px 12px"}}>
          {navItems.map(item=>(
            <button key={item.id} onClick={()=>setSection(item.id)} style={{width:"100%",display:"flex",alignItems:"center",gap:12,padding:"10px 14px",marginBottom:2,border:"none",cursor:"pointer",textAlign:"left",background:section===item.id?PINK_LT:"transparent",color:section===item.id?PINK2:GREY,fontWeight:section===item.id?500:400,fontSize:13,letterSpacing:".04em",transition:"all .15s"}}>
              <span style={{fontSize:13,opacity:.7}}>{item.icon}</span>
              {item.label}
            </button>
          ))}
        </nav>

        <div style={{padding:"16px 12px",borderTop:`1px solid ${PINK_BD}`}}>
          <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{textDecoration:"none"}}>
            <div style={{display:"flex",alignItems:"center",gap:9,padding:"11px 14px",background:"#f0fdf4",border:"1px solid #bbf7d0",fontSize:11,fontWeight:500,color:"#166534",cursor:"pointer",letterSpacing:".06em",textTransform:"uppercase"}}>
              <WAIcon size={14} color="#166534"/> WhatsApp Support
            </div>
          </a>
        </div>
      </div>

      {/* MAIN */}
      <div style={{flex:1,overflow:"auto"}}>
        <div style={{position:"sticky",top:0,zIndex:50,background:"rgba(255,255,255,.97)",backdropFilter:"blur(12px)",borderBottom:`1px solid ${PINK_BD}`,padding:"0 36px",height:58,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div style={{fontSize:13,fontWeight:500,letterSpacing:".1em",textTransform:"uppercase",color:BLACK}}>{navItems.find(n=>n.id===section)?.label}</div>
          <Logo size={50} />
        </div>

        <div style={{padding:32}}>

          {/* OVERVIEW */}
          {section==="overview" && (
            <div className="fade-in">
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(190px,1fr))",gap:1,background:PINK_BD,marginBottom:24,border:`1px solid ${PINK_BD}`}}>
                {[
                  {label:"Total Revenue",  value:`$${(totalRev/1000).toFixed(0)}k`, sub:"Last 12 months",      color:PINK},
                  {label:"Total Orders",   value:orders.length,                     sub:`${delivered} delivered`,color:BLACK},
                  {label:"Average Order",  value:`$${avgOrder}`,                    sub:"Per transaction",      color:BLACK},
                  {label:"Active Products",value:products.length,                   sub:"In catalog",           color:BLACK},
                ].map(stat=>(
                  <div key={stat.label} style={{background:WHITE,padding:"24px 26px"}}>
                    <div style={{fontSize:10,fontWeight:500,letterSpacing:".1em",textTransform:"uppercase",color:GREY,marginBottom:12}}>{stat.label}</div>
                    <div className="serif" style={{fontSize:36,fontWeight:500,color:stat.color,lineHeight:1,marginBottom:5}}>{stat.value}</div>
                    <div style={{fontSize:11,color:GREY_LT,letterSpacing:".04em"}}>{stat.sub}</div>
                  </div>
                ))}
              </div>

              <div style={{display:"grid",gridTemplateColumns:"1fr 340px",gap:24}}>
                <div style={{background:WHITE,border:`1px solid ${PINK_BD}`,padding:28}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:22}}>
                    <div>
                      <div style={{fontSize:13,fontWeight:500,color:BLACK,marginBottom:3}}>Revenue Overview</div>
                      <div style={{fontSize:11,color:GREY,letterSpacing:".04em"}}>Monthly · 2024–2025</div>
                    </div>
                    <span className="serif" style={{fontSize:24,fontWeight:500,color:PINK}}>${(totalRev/1000).toFixed(0)}k</span>
                  </div>
                  <RevenueChart/>
                </div>

                <div style={{background:WHITE,border:`1px solid ${PINK_BD}`,padding:24}}>
                  <div style={{fontSize:13,fontWeight:500,color:BLACK,marginBottom:18}}>Recent Orders</div>
                  {ORDERS.slice(0,5).map((o,i)=>(
                    <div key={o.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:i<4?`1px solid ${PINK_BD}`:"none"}}>
                      <div style={{width:32,height:32,background:PINK_LT,border:`1px solid ${PINK_BD}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:600,color:PINK2,flexShrink:0}}>{o.avatar}</div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:12,fontWeight:500,marginBottom:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:BLACK}}>{o.customer}</div>
                        <div style={{fontSize:10,color:GREY,letterSpacing:".04em"}}>{o.id} · {o.date}</div>
                      </div>
                      <div style={{textAlign:"right"}}>
                        <div style={{fontSize:13,fontWeight:500,color:BLACK,marginBottom:3}}>${o.total}</div>
                        <StatusLabel status={o.status}/>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* PRODUCTS */}
          {section==="products" && (
            <div className="fade-in">
              <div style={{display:"flex",gap:14,marginBottom:22,alignItems:"center"}}>
                <input className="input-field" style={{maxWidth:260}} placeholder="Search products…" value={pSearch} onChange={e=>setPSearch(e.target.value)}/>
                <button className="btn-primary" style={{whiteSpace:"nowrap",padding:"10px 22px"}} onClick={()=>showToast("Product editor coming soon")}>+ Add Product</button>
                <span style={{fontSize:11,color:GREY_LT,marginLeft:"auto",letterSpacing:".06em"}}>{filtProd.length} products</span>
              </div>
              <div style={{background:WHITE,border:`1px solid ${PINK_BD}`,overflow:"hidden"}}>
                <div style={{display:"grid",gridTemplateColumns:"2fr 1.2fr 70px 80px 100px 110px",padding:"10px 20px",borderBottom:`1px solid ${PINK_BD}`,fontSize:10,fontWeight:500,letterSpacing:".1em",textTransform:"uppercase",color:GREY}}>
                  {["Product","Category","Stock","Price","Tag","Actions"].map(h=><span key={h}>{h}</span>)}
                </div>
                {filtProd.map((p,i)=>(
                  <div key={p.id} style={{display:"grid",gridTemplateColumns:"2fr 1.2fr 70px 80px 100px 110px",padding:"14px 20px",borderBottom:i<filtProd.length-1?`1px solid ${PINK_BD}`:"none",alignItems:"center",background:i%2===0?WHITE:PINK_BG}}>
                    <div style={{display:"flex",alignItems:"center",gap:12}}>
                      <div style={{width:36,height:36,background:PINK_LT,border:`1px solid ${PINK_BD}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,color:GREY,letterSpacing:".04em",textTransform:"uppercase",textAlign:"center",padding:4,lineHeight:1.4}}>{p.name.split(" ").slice(0,2).join("\n")}</div>
                      <div>
                        <div style={{fontWeight:500,fontSize:13,color:BLACK}}>{p.name}</div>
                        <div style={{fontSize:10,color:GREY,letterSpacing:".04em"}}>{p.colors.join(", ")}</div>
                      </div>
                    </div>
                    <div style={{fontSize:11,color:GREY,letterSpacing:".04em"}}>{p.category}</div>
                    <div style={{fontSize:12,fontWeight:500,color:p.stock<=10?PINK2:"#2d6a45"}}>{p.stock}</div>
                    <div style={{fontSize:14,fontWeight:500,color:BLACK}}>${p.price}</div>
                    <div><TagLabel label={p.tag}/></div>
                    <div style={{display:"flex",gap:6}}>
                      <button className="btn-ghost" style={{padding:"5px 12px",fontSize:10}} onClick={()=>showToast(`Editing "${p.name}"`)}>Edit</button>
                      <button style={{background:"none",color:PINK2,border:`1px solid ${PINK_BD}`,padding:"5px 10px",fontSize:10,fontWeight:500,cursor:"pointer",letterSpacing:".06em"}} onClick={()=>{setProducts(ps=>ps.filter(x=>x.id!==p.id));showToast("Product removed","err");}}>Remove</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ORDERS */}
          {section==="orders" && (
            <div className="fade-in">
              <div style={{display:"flex",gap:12,marginBottom:22,flexWrap:"wrap",alignItems:"center"}}>
                <input className="input-field" style={{maxWidth:250}} placeholder="Search orders…" value={oSearch} onChange={e=>setOSearch(e.target.value)}/>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {["All","Processing","Shipped","Delivered","Cancelled"].map(f=>(
                    <button key={f} onClick={()=>setOFilter(f)} style={{padding:"7px 14px",fontSize:10,fontWeight:500,letterSpacing:".08em",textTransform:"uppercase",border:`1px solid ${oFilter===f?BLACK:PINK_BD}`,background:oFilter===f?BLACK:WHITE,color:oFilter===f?WHITE:GREY,cursor:"pointer",transition:"all .15s"}}>{f}</button>
                  ))}
                </div>
                <span style={{marginLeft:"auto",fontSize:11,color:GREY_LT,letterSpacing:".04em"}}>{filtOrd.length} orders</span>
              </div>
              <div style={{background:WHITE,border:`1px solid ${PINK_BD}`,overflow:"hidden"}}>
                <div style={{display:"grid",gridTemplateColumns:"100px 1fr 1fr 60px 90px 120px",padding:"10px 20px",borderBottom:`1px solid ${PINK_BD}`,fontSize:10,fontWeight:500,letterSpacing:".1em",textTransform:"uppercase",color:GREY}}>
                  {["Order","Customer","Note","Items","Total","Status"].map(h=><span key={h}>{h}</span>)}
                </div>
                {filtOrd.map((o,i)=>(
                  <div key={o.id} style={{display:"grid",gridTemplateColumns:"100px 1fr 1fr 60px 90px 120px",padding:"14px 20px",borderBottom:i<filtOrd.length-1?`1px solid ${PINK_BD}`:"none",alignItems:"center",background:i%2===0?WHITE:PINK_BG}}>
                    <div style={{fontSize:12,fontWeight:500,color:PINK}}>{o.id}</div>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <div style={{width:30,height:30,background:PINK_LT,border:`1px solid ${PINK_BD}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:600,color:PINK2,flexShrink:0}}>{o.avatar}</div>
                      <div>
                        <div style={{fontWeight:500,fontSize:12,color:BLACK}}>{o.customer}</div>
                        <div style={{fontSize:10,color:GREY,letterSpacing:".04em"}}>{o.date}</div>
                      </div>
                    </div>
                    <div style={{fontSize:11,color:GREY,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",letterSpacing:".02em"}}>{o.note}</div>
                    <div style={{fontSize:12,fontWeight:400,color:GREY}}>{o.items}</div>
                    <div style={{fontSize:14,fontWeight:500,color:BLACK}}>${o.total}</div>
                    <StatusLabel status={o.status}/>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ANALYTICS */}
          {section==="analytics" && (
            <div className="fade-in">
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:24}}>
                <div style={{background:WHITE,border:`1px solid ${PINK_BD}`,padding:28,gridColumn:"1/-1"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:22}}>
                    <div>
                      <div style={{fontSize:13,fontWeight:500,color:BLACK,marginBottom:3}}>Revenue · Apr 2024 – Mar 2025</div>
                      <div style={{fontSize:11,color:GREY,letterSpacing:".04em"}}>Total: <strong style={{color:PINK,fontWeight:500}}>${(totalRev/1000).toFixed(1)}k</strong></div>
                    </div>
                    <div style={{display:"flex",gap:8}}>
                      {["Monthly","Quarterly","Yearly"].map(t=><button key={t} className="btn-ghost" style={{padding:"6px 14px",fontSize:10}}>{t}</button>)}
                    </div>
                  </div>
                  <RevenueChart/>
                </div>

                <div style={{background:WHITE,border:`1px solid ${PINK_BD}`,padding:24}}>
                  <div style={{fontSize:13,fontWeight:500,color:BLACK,marginBottom:20}}>Top Products by Revenue</div>
                  {[
                    {name:"BBL Stage 2 Garment",      rev:12420,pct:82},
                    {name:"Complete Recovery Kit",    rev:9843, pct:65},
                    {name:"Tummy Tuck Garment",       rev:8550, pct:56},
                    {name:"Full Body Compression",    rev:6750, pct:44},
                  ].map(item=>(
                    <div key={item.name} style={{marginBottom:16}}>
                      <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                        <span style={{fontSize:12,fontWeight:400,color:BLACK,letterSpacing:".02em"}}>{item.name}</span>
                        <span style={{fontSize:12,fontWeight:500,color:PINK}}>${(item.rev/1000).toFixed(1)}k</span>
                      </div>
                      <div style={{height:6,background:PINK_LT,border:`1px solid ${PINK_BD}`,overflow:"hidden"}}>
                        <div style={{height:"100%",width:`${item.pct}%`,background:PINK,transition:"width .6s"}}/>
                      </div>
                    </div>
                  ))}
                </div>

                <div style={{background:WHITE,border:`1px solid ${PINK_BD}`,padding:24}}>
                  <div style={{fontSize:13,fontWeight:500,color:BLACK,marginBottom:20}}>Order Status</div>
                  {[
                    {label:"Delivered",  count:3,color:"#2d6a45"},
                    {label:"Shipped",    count:2,color:"#2c4fa0"},
                    {label:"Processing", count:1,color:"#9a6b1a"},
                    {label:"Cancelled",  count:1,color:PINK2},
                  ].map(item=>(
                    <div key={item.label} style={{display:"flex",alignItems:"center",gap:14,marginBottom:10,padding:"12px 16px",background:PINK_BG,border:`1px solid ${PINK_BD}`}}>
                      <div style={{width:8,height:8,background:item.color,flexShrink:0}}/>
                      <span style={{flex:1,fontSize:12,color:BLACK,letterSpacing:".02em"}}>{item.label}</span>
                      <span style={{fontWeight:500,fontSize:14,color:item.color}}>{item.count}</span>
                      <span style={{fontSize:10,background:`${item.color}18`,color:item.color,padding:"2px 8px",letterSpacing:".06em",fontWeight:500}}>{Math.round(item.count/orders.length*100)}%</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

        </div>
      </div>

      {toast && (
        <div className="slide-r" style={{position:"fixed",bottom:24,right:24,zIndex:500,background:WHITE,border:`1px solid ${toast.type==="err"?PINK_BD:PINK_BD}`,color:toast.type==="err"?PINK2:BLACK,padding:"13px 20px",fontSize:12,fontWeight:500,letterSpacing:".04em",boxShadow:"0 4px 24px rgba(0,0,0,.08)"}}>
          {toast.type==="err"?"Removed — ":"Saved — "}{toast.msg}
        </div>
      )}
    </div>
  );
};

/* ─────────────────────────────────────────
   RECOVERY GUIDE PAGE
───────────────────────────────────────── */
const RecoveryGuide = ({ onBack, onOpenCart, cartCount }) => {
  const [open, setOpen] = useState(null);

  const faqs = [
    { q:"When should I start wearing my compression garment?", a:"Most surgeons recommend wearing your Stage 1 garment immediately after surgery, typically within 24 hours. Always follow your surgeon's specific instructions as every procedure and body is different." },
    { q:"How long do I need to wear my garment?", a:"Stage 1 garments are typically worn for the first 4–6 weeks post-op, 24 hours a day except when showering. Stage 2 garments are usually worn for an additional 6–12 weeks depending on your surgeon's recommendation." },
    { q:"How do I know if my garment fits correctly?", a:"Your garment should feel firm and supportive without cutting into your skin or causing numbness. You should be able to breathe comfortably. If you experience severe discomfort, numbness, or skin changes, remove it and contact your surgeon." },
    { q:"Can I wash my compression garment?", a:"Yes — hand wash in cold water with mild soap and lay flat to dry. Never put it in the dryer as heat can damage the compression fabric. We recommend having 2 garments so you always have a clean one ready." },
    { q:"What size should I order?", a:"Order based on your pre-surgery measurements. Our size guide uses bust, waist, and hip measurements. If you're between sizes, size up for comfort during post-op swelling. We carry sizes S through 4XL." },
    { q:"Do I need both Stage 1 and Stage 2?", a:"For optimal results, yes. Stage 1 provides gentle compression for initial healing. Stage 2 provides firmer compression to help contour your results. Many surgeons consider both essential to the recovery process." },
  ];

  const weeks = [
    { w:"Week 1–2", title:"Initial Recovery", color:PINK_LT, border:PINK_BD, items:["Wear your Stage 1 garment 24/7 except when showering","Expect significant swelling and bruising — this is normal","Sleep in an elevated position to reduce swelling","Avoid any strenuous activity or lifting","Stay hydrated and follow your surgeon's diet recommendations"] },
    { w:"Week 3–4", title:"Early Healing", color:"#f0f7f0", border:"#c8e0c8", items:["Continue wearing Stage 1 garment as directed","Swelling will begin to gradually reduce","Short gentle walks are encouraged to promote circulation","You may begin to see early results emerging","Attend all follow-up appointments with your surgeon"] },
    { w:"Week 5–6", title:"Transition Phase", color:"#f0f3fb", border:"#c8d4f0", items:["Transition to your Stage 2 garment as directed by your surgeon","Compression becomes firmer to help shape your results","Light daily activities can resume","Avoid sitting directly on treated areas (BBL patients)","Fibrosis massage may be recommended by your surgeon"] },
    { w:"Week 7–12", title:"Active Recovery", color:"#fdf8ee", border:"#e8d8a0", items:["Continue Stage 2 garment for full contouring benefit","Most patients return to normal daily activities","Light exercise may be approved by your surgeon","Results continue to improve as swelling fully resolves","Use abdominal boards as directed to prevent fibrosis"] },
  ];

  return (
    <div style={{minHeight:"100vh",background:WHITE}}>

      {/* NAV */}
      <nav className="nav-inner" style={{position:"sticky",top:0,zIndex:100,background:WHITE,borderBottom:`1px solid ${PINK_BD}`,padding:"0 40px",height:70,display:"grid",gridTemplateColumns:"1fr auto 1fr",alignItems:"center",gap:24}}>
        <Logo size={70} onClick={onBack}/>
        <div className="nav-links" style={{display:"flex",gap:32,alignItems:"center"}}>
          <span onClick={onBack} style={{fontSize:11,fontWeight:400,color:GREY,cursor:"pointer",letterSpacing:".1em",textTransform:"uppercase"}} onMouseEnter={e=>e.target.style.color=BLACK} onMouseLeave={e=>e.target.style.color=GREY}>← Back to Shop</span>
        </div>
        <div className="nav-right" style={{display:"flex",gap:12,alignItems:"center",justifyContent:"flex-end"}}>
          <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{display:"flex",alignItems:"center",gap:6,color:"#25d366",textDecoration:"none",fontSize:11,fontWeight:500,letterSpacing:".06em",textTransform:"uppercase"}}>
            <WAIcon size={15} color="#25d366"/><span className="nav-wa-text">WhatsApp</span>
          </a>
          <div style={{width:1,height:16,background:PINK_BD}}/>
          <button onClick={onOpenCart} style={{background:"none",border:"none",padding:"4px 0",cursor:"pointer",display:"flex",alignItems:"center",gap:7,fontSize:11,fontWeight:500,color:BLACK,letterSpacing:".08em",textTransform:"uppercase"}}>
            Bag {cartCount>0 && <span style={{background:PINK,color:WHITE,minWidth:17,height:17,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:600}}>{cartCount}</span>}
          </button>
        </div>
      </nav>

      {/* HERO */}
      <div className="rg-hero" style={{background:PINK_BG,borderBottom:`1px solid ${PINK_BD}`,padding:"72px 48px 60px",textAlign:"center",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",left:"50%",top:"50%",transform:"translate(-50%,-50%)",width:500,height:500,borderRadius:"50%",background:PINK_LT,opacity:.4,zIndex:0}}/>
        <div style={{position:"relative",zIndex:1}}>
          <div style={{fontSize:10,letterSpacing:".22em",textTransform:"uppercase",color:PINK,marginBottom:16,fontWeight:500}}>Alo's Elevated Beauty</div>
          <h1 className="serif" style={{fontSize:"clamp(36px,5vw,72px)",fontWeight:400,lineHeight:1.05,marginBottom:20,color:BLACK}}>Your Post-Op <span style={{color:PINK,fontStyle:"italic"}}>Recovery Guide</span></h1>
          <p style={{fontSize:14,color:GREY,lineHeight:1.9,maxWidth:520,margin:"0 auto 32px",fontWeight:300}}>Everything you need to know about wearing your compression garment, caring for your body, and getting the best results from your procedure.</p>
          <button onClick={onBack} style={{background:"none",border:`1px solid ${PINK_BD}`,padding:"10px 24px",fontSize:11,fontWeight:500,color:GREY,letterSpacing:".1em",textTransform:"uppercase",cursor:"pointer"}}>← Back to Shop</button>
        </div>
      </div>

      {/* STAGE 1 VS STAGE 2 */}
      <div style={{padding:"72px 48px",borderBottom:`1px solid ${PINK_BD}`}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <div style={{fontSize:10,letterSpacing:".2em",textTransform:"uppercase",color:PINK,marginBottom:12,fontWeight:500}}>Understanding Your Garments</div>
          <h2 className="serif" style={{fontSize:"clamp(28px,3vw,44px)",fontWeight:400,color:BLACK}}>Stage 1 vs Stage 2 Explained</h2>
        </div>
        <div className="rg-stages" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:24,maxWidth:900,margin:"0 auto"}}>
          {[
            { stage:"Stage 1", sub:"Weeks 1–6", color:PINK_LT, border:PINK_BD, points:[
              "Gentle, soft compression for initial healing","Open-bust design for comfort","Front zipper for easy on/off","Worn immediately post-surgery","Accommodates post-op swelling","Soft powernet fabric against sensitive skin",
            ]},
            { stage:"Stage 2", sub:"Weeks 6–12+", color:"#f0f3fb", border:"#c8d4f0", points:[
              "Firmer compression to shape results","Helps reduce fibrosis and uneven contours","Worn once initial swelling subsides","Provides more defined contouring","Higher compression panels in key areas","Helps lock in your surgical results",
            ]},
          ].map(s=>(
            <div key={s.stage} style={{background:s.color,border:`1px solid ${s.border}`,padding:"36px 32px"}}>
              <div style={{fontSize:10,letterSpacing:".16em",textTransform:"uppercase",color:GREY,marginBottom:8,fontWeight:500}}>{s.sub}</div>
              <h3 className="serif" style={{fontSize:32,fontWeight:500,color:BLACK,marginBottom:24}}>{s.stage}</h3>
              {s.points.map(p=>(
                <div key={p} style={{display:"flex",gap:12,marginBottom:12,alignItems:"flex-start"}}>
                  <div style={{width:6,height:6,borderRadius:"50%",background:PINK,flexShrink:0,marginTop:6}}/>
                  <span style={{fontSize:13,color:GREY,lineHeight:1.7,fontWeight:300}}>{p}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* HOW TO PUT ON */}
      <div style={{padding:"72px 48px",borderBottom:`1px solid ${PINK_BD}`,background:PINK_BG}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <div style={{fontSize:10,letterSpacing:".2em",textTransform:"uppercase",color:PINK,marginBottom:12,fontWeight:500}}>Step by Step</div>
          <h2 className="serif" style={{fontSize:"clamp(28px,3vw,44px)",fontWeight:400,color:BLACK}}>How to Put On Your Garment</h2>
        </div>
        <div className="rg-steps" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:16,maxWidth:1000,margin:"0 auto"}}>
          {[
            { n:"01", title:"Wash Your Hands", desc:"Always start with clean hands to protect your healing incisions from bacteria." },
            { n:"02", title:"Sit or Lie Down", desc:"Find a comfortable seated or lying position. Don't try to put it on while standing." },
            { n:"03", title:"Step In Feet First", desc:"Step both feet through the bottom opening and pull the garment up to your thighs." },
            { n:"04", title:"Work It Up Slowly", desc:"Gently ease the garment up your body using small upward motions, smoothing as you go." },
            { n:"05", title:"Close the Hooks", desc:"Start from the bottom row of hooks and work your way up for the smoothest fit." },
            { n:"06", title:"Check for Comfort", desc:"Make sure there are no folds or creases pressing into your skin. Adjust until smooth." },
          ].map(s=>(
            <div key={s.n} style={{background:WHITE,border:`1px solid ${PINK_BD}`,padding:"28px 24px"}}>
              <div className="serif" style={{fontSize:36,fontWeight:400,color:PINK,opacity:.6,marginBottom:12,lineHeight:1}}>{s.n}</div>
              <div style={{fontSize:13,fontWeight:500,color:BLACK,marginBottom:8}}>{s.title}</div>
              <div style={{fontSize:12,color:GREY,lineHeight:1.8,fontWeight:300}}>{s.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* WEEK BY WEEK */}
      <div style={{padding:"72px 48px",borderBottom:`1px solid ${PINK_BD}`}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <div style={{fontSize:10,letterSpacing:".2em",textTransform:"uppercase",color:PINK,marginBottom:12,fontWeight:500}}>Your Recovery Timeline</div>
          <h2 className="serif" style={{fontSize:"clamp(28px,3vw,44px)",fontWeight:400,color:BLACK}}>What to Expect Week by Week</h2>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:16,maxWidth:1100,margin:"0 auto"}}>
          {weeks.map(w=>(
            <div key={w.w} style={{background:w.color,border:`1px solid ${w.border}`,padding:"32px 28px"}}>
              <div style={{fontSize:10,letterSpacing:".16em",textTransform:"uppercase",color:GREY,marginBottom:8,fontWeight:500}}>{w.w}</div>
              <h3 className="serif" style={{fontSize:24,fontWeight:500,color:BLACK,marginBottom:20}}>{w.title}</h3>
              {w.items.map(item=>(
                <div key={item} style={{display:"flex",gap:10,marginBottom:10,alignItems:"flex-start"}}>
                  <div style={{width:5,height:5,borderRadius:"50%",background:PINK,flexShrink:0,marginTop:7}}/>
                  <span style={{fontSize:12,color:GREY,lineHeight:1.7,fontWeight:300}}>{item}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* SIZING GUIDE */}
      <div style={{padding:"72px 48px",borderBottom:`1px solid ${PINK_BD}`,background:PINK_BG}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <div style={{fontSize:10,letterSpacing:".2em",textTransform:"uppercase",color:PINK,marginBottom:12,fontWeight:500}}>Find Your Fit</div>
          <h2 className="serif" style={{fontSize:"clamp(28px,3vw,44px)",fontWeight:400,color:BLACK}}>Sizing Guide</h2>
          <p style={{fontSize:13,color:GREY,maxWidth:480,margin:"16px auto 0",lineHeight:1.9,fontWeight:300}}>Measure yourself in the morning before swelling increases. For post-op sizing, use your pre-surgery measurements.</p>
        </div>
        <div className="size-table" style={{maxWidth:700,margin:"0 auto",border:`1px solid ${PINK_BD}`,background:WHITE}}>
          {[["Size","Bust","Waist","Hips"],["S","32–34\"","26–28\"","35–37\""],["M","34–36\"","28–30\"","37–39\""],["L","36–38\"","30–32\"","39–41\""],["XL","38–40\"","32–34\"","41–43\""],["2XL","40–43\"","34–37\"","43–46\""],["3XL","43–46\"","37–40\"","46–49\""],["4XL","46–50\"","40–44\"","49–53\""]].map((row,i)=>(
            <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",borderBottom:i<7?`1px solid ${PINK_BD}`:"none",background:i===0?PINK_LT:i%2===0?PINK_BG:WHITE}}>
              {row.map((cell,j)=>(
                <div key={j} style={{padding:"14px 20px",fontSize:i===0?10:13,fontWeight:i===0?500:300,color:i===0?GREY:BLACK,letterSpacing:i===0?".1em":"0",textTransform:i===0?"uppercase":"none"}}>{cell}</div>
              ))}
            </div>
          ))}
        </div>
        <p style={{textAlign:"center",fontSize:11,color:GREY_LT,marginTop:16,letterSpacing:".04em"}}>Not sure? Message us on WhatsApp for a personalized size recommendation.</p>
      </div>

      {/* POST-OP CARE TIPS */}
      <div style={{padding:"72px 48px",borderBottom:`1px solid ${PINK_BD}`}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <div style={{fontSize:10,letterSpacing:".2em",textTransform:"uppercase",color:PINK,marginBottom:12,fontWeight:500}}>Essential Tips</div>
          <h2 className="serif" style={{fontSize:"clamp(28px,3vw,44px)",fontWeight:400,color:BLACK}}>Post-Op Care Tips</h2>
        </div>
        <div className="rg-tips" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:16,maxWidth:1000,margin:"0 auto"}}>
          {[
            { title:"Stay Hydrated", tip:"Drink at least 8 glasses of water daily. Proper hydration supports healing and helps reduce swelling faster." },
            { title:"Walk Daily", tip:"Short gentle walks starting day 2–3 promote circulation and significantly reduce your risk of blood clots." },
            { title:"Avoid Heat", tip:"No hot baths, saunas, or direct sun exposure on treated areas for at least 6 weeks. Heat increases swelling." },
            { title:"Sleep Position", tip:"Depending on your procedure, sleep on your back elevated or stomach (BBL). Follow your surgeon's instructions." },
            { title:"Clean Your Garment", tip:"Hand wash daily in cold water. Bacteria build-up can cause infections. Having 2 garments makes this easy." },
            { title:"Attend Follow-Ups", tip:"Never skip your post-op appointments. Your surgeon monitors your healing and can catch issues early." },
          ].map(t=>(
            <div key={t.title} style={{border:`1px solid ${PINK_BD}`,padding:"28px 24px",background:WHITE}}>
              <div style={{width:32,height:2,background:PINK,marginBottom:16}}/>
              <div style={{fontSize:14,fontWeight:500,color:BLACK,marginBottom:10}}>{t.title}</div>
              <div style={{fontSize:13,color:GREY,lineHeight:1.8,fontWeight:300}}>{t.tip}</div>
            </div>
          ))}
        </div>
      </div>

      {/* FAQ */}
      <div style={{padding:"72px 48px",borderBottom:`1px solid ${PINK_BD}`,background:PINK_BG}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <div style={{fontSize:10,letterSpacing:".2em",textTransform:"uppercase",color:PINK,marginBottom:12,fontWeight:500}}>Got Questions?</div>
          <h2 className="serif" style={{fontSize:"clamp(28px,3vw,44px)",fontWeight:400,color:BLACK}}>Frequently Asked Questions</h2>
        </div>
        <div style={{maxWidth:740,margin:"0 auto"}}>
          {faqs.map((faq,i)=>(
            <div key={i} style={{borderBottom:`1px solid ${PINK_BD}`,overflow:"hidden"}}>
              <button onClick={()=>setOpen(open===i?null:i)} style={{width:"100%",background:"none",border:"none",padding:"22px 0",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",textAlign:"left",gap:16}}>
                <span style={{fontSize:14,fontWeight:500,color:BLACK,lineHeight:1.4}}>{faq.q}</span>
                <span style={{fontSize:20,color:PINK,flexShrink:0,lineHeight:1}}>{open===i?"−":"+"}</span>
              </button>
              {open===i && (
                <div style={{padding:"0 0 22px",fontSize:13,color:GREY,lineHeight:1.9,fontWeight:300}}>{faq.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div style={{background:BLACK,padding:"64px 48px",textAlign:"center"}}>
        <div style={{fontSize:10,letterSpacing:".18em",textTransform:"uppercase",color:PINK,marginBottom:16}}>Still Have Questions?</div>
        <h2 className="serif" style={{fontSize:"clamp(28px,3vw,44px)",fontWeight:400,color:WHITE,lineHeight:1.1,marginBottom:14}}>We're here to help you<br/><span style={{color:PINK,fontStyle:"italic"}}>every step</span> of the way.</h2>
        <p style={{fontSize:13,color:"rgba(255,255,255,.55)",maxWidth:440,margin:"0 auto 36px",lineHeight:1.9,fontWeight:300}}>Our specialists are available via WhatsApp to answer your questions and help you choose the right garment for your procedure.</p>
        <div style={{display:"flex",gap:14,justifyContent:"center",flexWrap:"wrap"}}>
          <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{textDecoration:"none"}}>
            <button style={{background:"#25d366",color:WHITE,border:"none",padding:"16px 36px",fontSize:12,fontWeight:500,cursor:"pointer",letterSpacing:".1em",textTransform:"uppercase",display:"flex",alignItems:"center",gap:10}}>
              <WAIcon size={16} color={WHITE}/> Chat on WhatsApp
            </button>
          </a>
          <button onClick={onBack} style={{background:"none",border:`1px solid rgba(255,255,255,.3)`,color:WHITE,padding:"16px 36px",fontSize:12,fontWeight:500,cursor:"pointer",letterSpacing:".1em",textTransform:"uppercase"}}>
            Shop Garments
          </button>
        </div>
      </div>

      {/* FOOTER */}
      <div className="footer" style={{background:WHITE,borderTop:`1px solid ${PINK_BD}`,padding:"28px 48px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
        <Logo size={60} onClick={onBack}/>
        <div style={{fontSize:11,color:GREY_LT,letterSpacing:".06em"}}>© 2026 Alo's Elevated Beauty. All rights reserved.</div>
        <div style={{display:"flex",gap:24,fontSize:11,color:GREY,letterSpacing:".08em",textTransform:"uppercase"}}>
          <span onClick={onBack} style={{cursor:"pointer"}} onMouseEnter={e=>e.target.style.color=PINK} onMouseLeave={e=>e.target.style.color=GREY}>← Shop</span>
          <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{color:GREY,textDecoration:"none"}} onMouseEnter={e=>e.target.style.color=PINK} onMouseLeave={e=>e.target.style.color=GREY}>Contact</a>
        </div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────
   RETURNS PAGE
───────────────────────────────────────── */
const ReturnsPage = ({onBack,onOpenCart,cartCount}) => (
  <div style={{minHeight:"100vh",background:WHITE}}>
    <nav className="nav-inner" style={{position:"sticky",top:0,zIndex:100,background:WHITE,borderBottom:`1px solid ${PINK_BD}`,padding:"0 40px",height:70,display:"grid",gridTemplateColumns:"1fr auto 1fr",alignItems:"center",gap:24}}>
      <Logo size={70} onClick={onBack}/>
      <div className="nav-links" style={{display:"flex",gap:32,alignItems:"center"}}>
        <span onClick={onBack} style={{fontSize:11,fontWeight:400,color:GREY,cursor:"pointer",letterSpacing:".1em",textTransform:"uppercase"}} onMouseEnter={e=>e.target.style.color=BLACK} onMouseLeave={e=>e.target.style.color=GREY}>← Back to Shop</span>
      </div>
      <div className="nav-right" style={{display:"flex",gap:12,alignItems:"center",justifyContent:"flex-end"}}>
        <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{display:"flex",alignItems:"center",gap:6,color:"#25d366",textDecoration:"none",fontSize:11,fontWeight:500,letterSpacing:".06em",textTransform:"uppercase"}}>
          <WAIcon size={15} color="#25d366"/><span className="nav-wa-text">WhatsApp</span>
        </a>
        <div style={{width:1,height:16,background:PINK_BD}}/>
        <button onClick={onOpenCart} style={{background:"none",border:"none",padding:"4px 0",cursor:"pointer",display:"flex",alignItems:"center",gap:7,fontSize:11,fontWeight:500,color:BLACK,letterSpacing:".08em",textTransform:"uppercase"}}>
          Bag {cartCount>0 && <span style={{background:PINK,color:WHITE,minWidth:17,height:17,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:600}}>{cartCount}</span>}
        </button>
      </div>
    </nav>
    <div style={{background:PINK_BG,borderBottom:`1px solid ${PINK_BD}`,padding:"64px 48px 52px",textAlign:"center"}}>
      <div style={{fontSize:10,letterSpacing:".22em",textTransform:"uppercase",color:PINK,marginBottom:14,fontWeight:500}}>Our Promise to You</div>
      <h1 className="serif" style={{fontSize:"clamp(36px,5vw,64px)",fontWeight:400,lineHeight:1.05,marginBottom:18,color:BLACK}}>10-Day Return <span style={{color:PINK,fontStyle:"italic"}}>Policy</span></h1>
      <p style={{fontSize:14,color:GREY,lineHeight:1.9,maxWidth:520,margin:"0 auto 28px",fontWeight:300}}>We want you to feel completely confident in your purchase. If your garment doesn't fit or meet your expectations, we make returns simple and stress-free.</p>
      <button onClick={onBack} style={{background:"none",border:`1px solid ${PINK_BD}`,padding:"10px 24px",fontSize:11,fontWeight:500,color:GREY,letterSpacing:".1em",textTransform:"uppercase",cursor:"pointer"}}>← Back to Shop</button>
    </div>
    <div style={{maxWidth:800,margin:"0 auto",padding:"64px 48px"}}>
      {[
        {title:"10-Day Return Window", body:"You have 10 days from the date of delivery to request a return or exchange. Items must be returned with tags still attached and in zero-damage condition — unworn, unwashed, no stains, odors, or alterations."},
        {title:"Exchanges", body:"Need a different size or color? We're happy to exchange your garment within the 10-day window subject to availability. Exchanges for a different size are our most common request and we process them as quickly as possible so your recovery is never interrupted."},
        {title:"Refunds", body:"Approved refunds are processed within 5–7 business days of us receiving and inspecting your return. We will confirm the refund directly through WhatsApp once it has been issued."},
      ].map(s=>(
        <div key={s.title} style={{marginBottom:48,paddingBottom:48,borderBottom:`1px solid ${PINK_BD}`}}>
          <div style={{width:32,height:2,background:PINK,marginBottom:20}}/>
          <h2 className="serif" style={{fontSize:28,fontWeight:500,color:BLACK,marginBottom:14}}>{s.title}</h2>
          <p style={{fontSize:14,color:GREY,lineHeight:1.9,fontWeight:300}}>{s.body}</p>
        </div>
      ))}
      <div style={{marginBottom:48,paddingBottom:48,borderBottom:`1px solid ${PINK_BD}`}}>
        <div style={{width:32,height:2,background:PINK,marginBottom:20}}/>
        <h2 className="serif" style={{fontSize:28,fontWeight:500,color:BLACK,marginBottom:14}}>What's Eligible for Return</h2>
        <p style={{fontSize:14,color:GREY,lineHeight:1.9,fontWeight:300,marginBottom:16}}>To be eligible for a return, your garment must meet the following conditions:</p>
        {["Unworn and unwashed — must be in original condition","Tags still attached — must not be removed","Zero damage — no stains, odors, or alterations","Requested within 10 days of delivery"].map(item=>(
          <div key={item} style={{display:"flex",gap:14,marginBottom:12,alignItems:"flex-start"}}>
            <div style={{width:6,height:6,borderRadius:"50%",background:PINK,flexShrink:0,marginTop:7}}/>
            <span style={{fontSize:13,color:GREY,lineHeight:1.7,fontWeight:300}}>{item}</span>
          </div>
        ))}
        <p style={{fontSize:13,color:GREY,lineHeight:1.9,fontWeight:300,marginTop:16,fontStyle:"italic"}}>For hygiene reasons, garments that have been worn cannot be returned. If you are unsure about sizing before wearing, please reach out on WhatsApp first.</p>
      </div>
      <div style={{marginBottom:48}}>
        <div style={{width:32,height:2,background:PINK,marginBottom:20}}/>
        <h2 className="serif" style={{fontSize:28,fontWeight:500,color:BLACK,marginBottom:14}}>How to Start a Return</h2>
        {[
          {n:"01",t:"Message us on WhatsApp",d:"Send us a message at wa.link/35yhqt with your order details and reason for return. We respond within 24 hours."},
          {n:"02",t:"We'll confirm eligibility",d:"We'll review your request and confirm whether your return qualifies, then send return instructions."},
          {n:"03",t:"Ship your garment back",d:"Pack securely and ship using a trackable method. You are responsible for return shipping unless the item was defective."},
          {n:"04",t:"Receive your refund or exchange",d:"Once received and inspected, we'll process your refund or ship your exchange within 5–7 business days."},
        ].map(s=>(
          <div key={s.n} style={{display:"flex",gap:24,marginBottom:24,alignItems:"flex-start"}}>
            <div className="serif" style={{fontSize:32,fontWeight:400,color:PINK,opacity:.5,lineHeight:1,flexShrink:0,width:40}}>{s.n}</div>
            <div>
              <div style={{fontSize:14,fontWeight:500,color:BLACK,marginBottom:6}}>{s.t}</div>
              <div style={{fontSize:13,color:GREY,lineHeight:1.8,fontWeight:300}}>{s.d}</div>
            </div>
          </div>
        ))}
      </div>
      <div style={{background:PINK_BG,border:`1px solid ${PINK_BD}`,padding:"32px 36px",textAlign:"center"}}>
        <div className="serif" style={{fontSize:24,fontWeight:400,color:BLACK,marginBottom:10}}>Still have questions?</div>
        <p style={{fontSize:13,color:GREY,lineHeight:1.8,fontWeight:300,marginBottom:24}}>Our team is available via WhatsApp to help with sizing, returns, or anything else.</p>
        <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{textDecoration:"none"}}>
          <button style={{background:"#25d366",color:WHITE,border:"none",padding:"14px 32px",fontSize:12,fontWeight:500,cursor:"pointer",letterSpacing:".1em",textTransform:"uppercase",display:"inline-flex",alignItems:"center",gap:10}}>
            <WAIcon size={15} color={WHITE}/> Chat on WhatsApp
          </button>
        </a>
      </div>
    </div>
    <div className="footer" style={{background:WHITE,borderTop:`1px solid ${PINK_BD}`,padding:"28px 48px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
      <Logo size={60} onClick={onBack}/><div style={{fontSize:11,color:GREY_LT}}>© 2026 Alo's Elevated Beauty. All rights reserved.</div>
      <div style={{display:"flex",gap:24,fontSize:11,color:GREY,letterSpacing:".08em",textTransform:"uppercase"}}>
        <span onClick={onBack} style={{cursor:"pointer"}} onMouseEnter={e=>e.target.style.color=PINK} onMouseLeave={e=>e.target.style.color=GREY}>← Shop</span>
        <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{color:GREY,textDecoration:"none"}} onMouseEnter={e=>e.target.style.color=PINK} onMouseLeave={e=>e.target.style.color=GREY}>Contact</a>
      </div>
    </div>
  </div>
);

/* ─────────────────────────────────────────
   HOW TO ORDER PAGE
───────────────────────────────────────── */
const HowToOrderPage = ({onBack,onShop,onOpenCart,cartCount}) => (
  <div style={{minHeight:"100vh",background:WHITE}}>
    <nav className="nav-inner" style={{position:"sticky",top:0,zIndex:100,background:WHITE,borderBottom:`1px solid ${PINK_BD}`,padding:"0 40px",height:70,display:"grid",gridTemplateColumns:"1fr auto 1fr",alignItems:"center",gap:24}}>
      <Logo size={70} onClick={onBack}/>
      <div className="nav-links" style={{display:"flex",gap:32,alignItems:"center"}}>
        <span onClick={onBack} style={{fontSize:11,fontWeight:400,color:GREY,cursor:"pointer",letterSpacing:".1em",textTransform:"uppercase"}} onMouseEnter={e=>e.target.style.color=BLACK} onMouseLeave={e=>e.target.style.color=GREY}>← Back to Shop</span>
      </div>
      <div className="nav-right" style={{display:"flex",gap:12,alignItems:"center",justifyContent:"flex-end"}}>
        <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{display:"flex",alignItems:"center",gap:6,color:"#25d366",textDecoration:"none",fontSize:11,fontWeight:500,letterSpacing:".06em",textTransform:"uppercase"}}>
          <WAIcon size={15} color="#25d366"/><span className="nav-wa-text">WhatsApp</span>
        </a>
        <div style={{width:1,height:16,background:PINK_BD}}/>
        <button onClick={onOpenCart} style={{background:"none",border:"none",padding:"4px 0",cursor:"pointer",display:"flex",alignItems:"center",gap:7,fontSize:11,fontWeight:500,color:BLACK,letterSpacing:".08em",textTransform:"uppercase"}}>
          Bag {cartCount>0 && <span style={{background:PINK,color:WHITE,minWidth:17,height:17,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:600}}>{cartCount}</span>}
        </button>
      </div>
    </nav>
    <div style={{background:PINK_BG,borderBottom:`1px solid ${PINK_BD}`,padding:"64px 48px 52px",textAlign:"center"}}>
      <div style={{fontSize:10,letterSpacing:".22em",textTransform:"uppercase",color:PINK,marginBottom:14,fontWeight:500}}>Simple & Personal</div>
      <h1 className="serif" style={{fontSize:"clamp(36px,5vw,64px)",fontWeight:400,lineHeight:1.05,marginBottom:18,color:BLACK}}>How to <span style={{color:PINK,fontStyle:"italic"}}>Order</span></h1>
      <p style={{fontSize:14,color:GREY,lineHeight:1.9,maxWidth:500,margin:"0 auto 28px",fontWeight:300}}>We take orders directly through WhatsApp so we can make sure you get exactly the right garment, size, and color for your recovery.</p>
      <button onClick={onBack} style={{background:"none",border:`1px solid ${PINK_BD}`,padding:"10px 24px",fontSize:11,fontWeight:500,color:GREY,letterSpacing:".1em",textTransform:"uppercase",cursor:"pointer"}}>← Back to Shop</button>
    </div>
    <div style={{maxWidth:800,margin:"0 auto",padding:"64px 48px"}}>
      {[
        {n:"01",t:"Browse & Choose Your Style",d:"We offer two Stage 2 garments. The Zipper style is great for earlier in Stage 2 — easy to put on and take off while still providing firm compression. The Hook style delivers maximum compression and a more snatched silhouette, and is best recommended once your mid-abdomen has had adequate time to heal. Not sure? Message us and we'll guide you."},
        {n:"02",t:"Check Your Size",d:"We carry sizes S through 4XL in both styles. Use the sizing guide in our Recovery Guide section. Measure your waist and hips before surgery for the most accurate fit. If you're between sizes, sizing up is usually the more comfortable choice during initial swelling."},
        {n:"03",t:"Message Us on WhatsApp",d:"Send us a message at wa.link/35yhqt with: your chosen style (Zipper or Hook), your size, your color (Black or Cocoa), your full name and delivery address. We'll confirm availability and send payment details right away."},
        {n:"04",t:"Complete Your Payment",d:"We'll send you a secure payment link directly through WhatsApp. Payment is quick and straightforward. Once confirmed we'll prepare your order immediately."},
        {n:"05",t:"We Ship Your Order",d:"Your garment is carefully packaged and shipped within 1–2 business days of payment confirmation. We'll send your tracking number via WhatsApp so you can follow your order every step of the way."},
        {n:"06",t:"Receive & Recover",d:"Your garment arrives ready to wear. If you have any questions about how to put it on, care for it, or anything else about your recovery — check our Recovery Guide or message us anytime. We're with you through every stage."},
      ].map((s,i)=>(
        <div key={s.n} style={{display:"flex",gap:28,marginBottom:40,paddingBottom:40,borderBottom:i<5?`1px solid ${PINK_BD}`:"none",alignItems:"flex-start"}}>
          <div className="serif" style={{fontSize:48,fontWeight:400,color:PINK,opacity:.4,lineHeight:1,flexShrink:0,width:56}}>{s.n}</div>
          <div>
            <div style={{fontSize:16,fontWeight:500,color:BLACK,marginBottom:10}}>{s.t}</div>
            <div style={{fontSize:13,color:GREY,lineHeight:1.9,fontWeight:300}}>{s.d}</div>
          </div>
        </div>
      ))}
      <div style={{background:BLACK,padding:"40px",textAlign:"center"}}>
        <div style={{fontSize:10,letterSpacing:".18em",textTransform:"uppercase",color:PINK,marginBottom:14}}>Ready to Order?</div>
        <h2 className="serif" style={{fontSize:32,fontWeight:400,color:WHITE,lineHeight:1.1,marginBottom:12}}>Let's get you the perfect fit.</h2>
        <p style={{fontSize:13,color:"rgba(255,255,255,.55)",maxWidth:420,margin:"0 auto 28px",lineHeight:1.9,fontWeight:300}}>Message us on WhatsApp and we'll have you set up in minutes.</p>
        <div style={{display:"flex",gap:14,justifyContent:"center",flexWrap:"wrap"}}>
          <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{textDecoration:"none"}}>
            <button style={{background:"#25d366",color:WHITE,border:"none",padding:"14px 32px",fontSize:12,fontWeight:500,cursor:"pointer",letterSpacing:".1em",textTransform:"uppercase",display:"inline-flex",alignItems:"center",gap:10}}>
              <WAIcon size={15} color={WHITE}/> Order on WhatsApp
            </button>
          </a>
          <button onClick={onShop} style={{background:"none",border:`1px solid rgba(255,255,255,.3)`,color:WHITE,padding:"14px 28px",fontSize:12,fontWeight:500,cursor:"pointer",letterSpacing:".1em",textTransform:"uppercase"}}>View Garments</button>
        </div>
      </div>
    </div>
    <div className="footer" style={{background:WHITE,borderTop:`1px solid ${PINK_BD}`,padding:"28px 48px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
      <Logo size={60} onClick={onBack}/><div style={{fontSize:11,color:GREY_LT}}>© 2026 Alo's Elevated Beauty. All rights reserved.</div>
      <div style={{display:"flex",gap:24,fontSize:11,color:GREY,letterSpacing:".08em",textTransform:"uppercase"}}>
        <span onClick={onBack} style={{cursor:"pointer"}} onMouseEnter={e=>e.target.style.color=PINK} onMouseLeave={e=>e.target.style.color=GREY}>← Shop</span>
        <a href="https://wa.link/35yhqt" target="_blank" rel="noreferrer" style={{color:GREY,textDecoration:"none"}} onMouseEnter={e=>e.target.style.color=PINK} onMouseLeave={e=>e.target.style.color=GREY}>Contact</a>
      </div>
    </div>
  </div>
);

export default function App() {
  const [page, setPage]          = useState("store");
  const [cart,setCart]           = useState([]);
  const [cartOpen,setCartOpen]   = useState(false);

  const addToCart = item => {
    setCart(prev=>{
      const ex = prev.find(i=>i.id===item.id&&i.size===item.size&&i.color===item.color);
      if (ex) return prev.map(i=>i.id===item.id&&i.size===item.size&&i.color===item.color?{...i,qty:i.qty+item.qty}:i);
      return [...prev,item];
    });
    setCartOpen(true);
  };

  const cartCount = cart.reduce((s,i)=>s+i.qty,0);
  const goTo = p => { setPage(p); window.scrollTo(0,0); };

  return (
    <>
      <style>{CSS}</style>
      {page==="guide"   && <RecoveryGuide   onBack={()=>goTo("store")} onOpenCart={()=>setCartOpen(true)} cartCount={cartCount}/>}
      {page==="returns" && <ReturnsPage     onBack={()=>goTo("store")} onOpenCart={()=>setCartOpen(true)} cartCount={cartCount}/>}
      {page==="order"   && <HowToOrderPage  onBack={()=>goTo("store")} onShop={()=>goTo("store")} onOpenCart={()=>setCartOpen(true)} cartCount={cartCount}/>}
      {page==="store"   && <Storefront cart={cart} onAdd={addToCart} onOpenCart={()=>setCartOpen(true)} onGuide={()=>goTo("guide")} onOrder={()=>goTo("order")} onReturns={()=>goTo("returns")}/>}
      {cartOpen && (
        <CartDrawer
          cart={cart}
          onClose={()=>setCartOpen(false)}
          onRemove={(id,s,c)=>setCart(prev=>prev.filter(i=>!(i.id===id&&i.size===s&&i.color===c)))}
          onQty={(id,s,c,d)=>setCart(prev=>prev.map(i=>i.id===id&&i.size===s&&i.color===c?{...i,qty:Math.max(1,i.qty+d)}:i))}
        />
      )}
    </>
  );
}
